export default __webpack_public_path__ + "static/media/about3.085ad4f6.jpg";